import {Component} from '@angular/core';
import {CommonService} from "../../services/common.service";
import {Router} from "@angular/router";


declare var google: any;
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-google-translate',
  template: `
    <div id="google_translate_element"></div>`,
  styleUrls: ['./google-translate.component.css']
})
export class GoogleTranslateComponent {

  constructor() {
  }

  ngAfterViewInit() {
    let waitingForGoogleLoad = setInterval(function () {
      const populateGoogleTranslate = () => {
        new google.translate.TranslateElement({
          pageLanguage: 'en, es',
          includedLanguages: 'ar,en,zh-CN,es,tl,ko,ja,'
        }, 'google_translate_element');

        $("#google_translate_element").html(google.translate.TranslateElement().ia)

        const select = $('#google_translate_element .goog-te-gadget > div ');
        $('#google_translate_element .goog-te-gadget').empty()
        $('#google_translate_element .goog-te-gadget').html(select);

        if (!$('#google_translate_element .goog-te-gadget').length) {
          if (!location.href?.includes('login') && !location.href?.includes('password')) {
            setTimeout(() => populateGoogleTranslate(), 1000);
          }
        }
      }

      if (typeof (google) != 'undefined' && typeof (google.translate.TranslateElement) != 'undefined' && typeof (google.translate.TranslateElement.InlineLayout) != 'undefined') {
        clearInterval(waitingForGoogleLoad);

        populateGoogleTranslate();
      }
    }, 1000);
  }
}
